import api from "@/services/api";
import { Promise } from "core-js";
import route from "@/router/index";

const BASE_URL = "/credit-cards";

//#region state
const state = {
  listCreditCards: [],
  creditCards: [],
  reconciliations: [],
};
//#endregion

//#region getters
const getters = {};
//#region

//#region actions
const actions = {
  async create(context, body) {
    try {
      const response = await api.post(BASE_URL, body);
      if (response.status === 200) {
        route.push({ name: "Credit Card" });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getAll(context) {
    try {
      const response = await api.get(BASE_URL);
      if (response.status === 200) {
        context.commit("SET_CREDIT_CARDS", response.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getById(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/${id}`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getListCreditCard() {
    try {
      const response = await api.get(`${BASE_URL}/dropdown`);
      if (response.status === 200) {
        return Promise.resolve(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getReconciliationCreditCard(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/reconciliation/chart-of-account/${id}`);
      if (response.status === 200) {
        return Promise.resolve(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getInvoiceDetail() {
    try {
      const response = await api.get(`${BASE_URL}/reconciliation/transaction/detail`);
      if (response.status === 200) {
        return Promise.resolve(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getReconciliations(context) {
    try {
      const response = await api.get(`${BASE_URL}/reconciliation`);
      if (response.status === 200) {
        context.commit("SET_RECONCILIATIONS", response.data);
        return Promise.resolve(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getReconciliationDetail(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/reconciliation/${id}`);
      if (response.status === 200) {
        return Promise.resolve(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async saveReconciliation(context, body) {
    try {
      const response = await api.post(`${BASE_URL}/reconciliation`, body);
      if (response.status === 200) {
        route.push({ name: "Reconciliation Credit Card" });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
//#endregion

//#region mutations
const mutations = {
  SET_CREDIT_CARDS(state, payload) {
    state.creditCards = payload;
  },
  SET_RECONCILIATIONS(state, payload) {
    state.reconciliations = payload;
  },
  SET_LIST_CHECK(state, payload) {
    state.listCreditCards = payload;
  },
};
//#endregion

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
